import PropTypes from 'prop-types'

function PersonCircle ({ size = 24, imageUrl, className = '' }) {
  return (
    <div
      className={`rounded-circle ${className}`}
      style={{
        backgroundImage: `url(${imageUrl}), url(/static/img/person.png)`,
        backgroundColor: '#717f93',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        height: `${size}px`,
        width: `${size}px`
      }}
    />
  )
}

PersonCircle.propTypes = {
  size: PropTypes.number,
  imageUrl: PropTypes.string,
  className: PropTypes.string
}

export default PersonCircle
